import { getCookiePermissions, PermissionMapping } from "~/composables/states";

export default defineNuxtPlugin(() => {
  const marketingCookie = getCookiePermissions(PermissionMapping.MARKETING)

  if (marketingCookie.value) injectKlarna();
  else watch(marketingCookie, (accepted) => {
      if (accepted) injectKlarna();
    },
  { immediate: false });

  function injectKlarna() {
    if (document?.querySelector('script[src*="klarna.com/web-sdk"]')) return;

    useHead({
      script: [
        {
          async: true,
          src: "https://js.klarna.com/web-sdk/v1/klarna.js",
          "data-client-id": "06ff54c5-d130-5d4f-80ef-35fbb81542be",
          "data-environment": useRuntimeConfig().public.useKlarnaPlayground
            ? "playground"
            : "production",
        },
      ],
    })
  };
})